import { createEvent } from '@cobuildlab/react-simple-state';

export const OnHandleAuth = createEvent<boolean>();
export const OnHandleAuthError = createEvent<Error>();
export const OnResendVerificationEmail = createEvent<string>();
export const OnResendVerificationEmailError = createEvent<Error>();
